import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { UpdateTag, UpdateTagDefaultValues } from 'src/app/components/tags/tags';
import { AuthService } from 'src/app/services/auth.service';
import { TagsService } from 'src/app/services/tag-service.service';

@Component({
    selector: 'app-view-tag',
    templateUrl: './view-tag.component.html',
    styleUrls: ['./view-tag.component.scss'],
    standalone: false
})
export class ViewTagComponent {

  tag:UpdateTag=UpdateTagDefaultValues();
  tagCategories: any[] = [];
  selectedCategory: any[] = [];
  selectedCategoryName: any[] = [];
  tagid: string = '';
  tagStatus: string = "active";
  hideReviewPanel: boolean = true;
  auditLogs: any[] = [];
  pageName = CheckPageAccess.TAGS
  showEditdButton = this.authservice.getAccessControl().editTags;

  constructor(public _tagservice: TagsService,
    public router: Router,
    public route: ActivatedRoute,
    private authservice: AuthService) {
  }

  async ngOnInit(): Promise<void> {
    await this.route.params.subscribe(params => {
      this.tagid = params['id'];
       this._tagservice.getTagDetailsById(params['id']).subscribe({
        next: (details) => {
          this.tag = details;
          this.selectedCategory = details.tagCategories;
          this.selectedCategoryName = this.selectedCategory.map(i => i.categoryName);

          if(this.tag.isActive) {
            this.tagStatus="active";
          } else {
            this.tagStatus = "inactive";
          }

          this._tagservice.getAllCategories().subscribe({
            next: (data) => {
              this.tagCategories = data
            },
            error: (error) => console.log(error)
          });
        }
      });
    });

    await this._tagservice.getTagAuditLogs(this.tagid).subscribe({
      next:(logs) => {
        this.auditLogs = logs;
      }
    });
  }

  navigate() {
    this.router.navigate(['/edit-tag/'+this.tagid]);
  }

}
